"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var $dyn;
(function ($dyn) {
    var DynReact;
    (function (DynReact) {
        var UI;
        (function (UI) {
            var Tile = /** @class */ (function (_super) {
                __extends(Tile, _super);
                function Tile() {
                    return _super !== null && _super.apply(this, arguments) || this;
                }
                Tile.prototype.render = function () {
                    var classes = "tile modulesFlyout-tile";
                    classes += (this.props.Favorite) ? " modulesFlyout-isFavorite" : "";
                    var imageContent;
                    // This is essentially a copy/paste of similar code for the image binding handler in html-binding-handlers.ts
                    switch (this.props.ImageType) {
                        case $dyn.ui.ImageType.symbol:
                            var symbolClass = this.props.Image + "-symbol";
                            if (symbolClass.match(/\s+/g)) {
                                symbolClass = "imageBinder-emptyImage";
                            }
                            var symbolClasses = "tile-image " + symbolClass;
                            imageContent = (React.createElement("span", { className: symbolClasses, "data-dyn-image-type": "Symbol" }));
                            break;
                        case $dyn.ui.ImageType.url:
                        case $dyn.ui.ImageType._axResource:
                            imageContent = (React.createElement("span", { className: "tile-image", "data-dyn-image-type": "Image" },
                                React.createElement("img", { className: "imageBinder-image", src: this.props.Image })));
                            break;
                        case $dyn.ui.ImageType.base64:
                            var imageData = "data:image/png;base64," + this.props.Image;
                            imageContent = (React.createElement("span", { className: "tile-image", "data-dyn-image-type": "Image" },
                                React.createElement("img", { className: "imageBinder-image", src: imageData })));
                            break;
                    }
                    return (React.createElement("div", { "aria-label": this.props.Label, className: classes, "data-dyn-button-display": $dyn.ui.ButtonDisplay.backgroundImage, "data-dyn-selected": this.props.Selected, "data-dyn-tile-size": "Wide", "data-dyn-title": this.props.Label, onClick: this.handleClick, onKeyDown: this.keyHandler, role: "link", tabIndex: -1 },
                        imageContent,
                        React.createElement("span", { className: "tile-text", onMouseEnter: this.onmouseenter, "aria-hidden": true }, this.props.Label),
                        React.createElement("div", { className: "modulesFlyout-favoriteIcon", "data-dyn-title": this.favoriteText(), "aria-hidden": true, onMouseEnter: this.onmouseenter, onClick: this.clickFavorite })));
                };
                return Tile;
            }(DynReact.Navigation));
            UI.Tile = Tile;
        })(UI = DynReact.UI || (DynReact.UI = {}));
    })(DynReact = $dyn.DynReact || ($dyn.DynReact = {}));
})($dyn || ($dyn = {}));

//# sourceMappingURL=Tile.js.map
